import { trackStructEvent } from "@rtl_nl/rtl-snowplow";
import { globalVars } from "./variables";

/**
 *
 */
function initFaqTracking() {
    document.addEventListener("click", (e) => {
        /**
         * opening and closing FAQs
         */
        for (const questionToggle of document.querySelectorAll(
            ".faq .accordion-title"
        )) {
            if (questionToggle.contains(e.target)) {

                // get event action, show or hide question
                const eventAction = questionToggle
                    .closest(".accordion-item")
                    .classList.contains("active")
                    ? "question-show"
                    : "question-hide";

                // get label, the question
                const eventLabel =
                    questionToggle.querySelector("span").innerText || "";

                // get question position (index)
                const question = questionToggle.closest(".accordion-item");
                const questionWrapperChildren = question.parentElement.childNodes;
                let questionIndex = '0';

                for (let i = 0; i<questionWrapperChildren.length; i++) {
                    if (questionWrapperChildren[i] == question) {
                        questionIndex = toString(i+1);
                        break;
                    }
                }

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: "faq",
                    action: eventAction,
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "faq-accordion",
                        elementType: "accordion-item",
                        elementName: "faq",
                        elementLabel: eventLabel,
                        elementPosition: questionIndex,
                    },
                });
                return;
            }
        }
    });
}

export { initFaqTracking };
